import { render, staticRenderFns } from "./DetalleDespacho2.vue?vue&type=template&id=0f006b02&"
import script from "./DetalleDespacho2.vue?vue&type=script&lang=js&"
export * from "./DetalleDespacho2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports